import { AddressRegistration } from "@/components/booking/create/AddressRegistration";
import { useDesktopLayout } from "@/hooks/use-desktop-layout";

export default function Step2Screen() {
  const desktop = useDesktopLayout();

  return <AddressRegistration desktopLayout={desktop} />;
}
